import { getActiveCourse } from '../../utils/course';
import { getCourses } from '../../firebase/utils';
import Context from './index';
import React, { useEffect, useState } from 'react';

const CourseProvider = (props) => {
    const [courses, setCourses] = useState([])
    const [activeCourse, setActiveCourse] = useState(null)

    const fetchCourses = async () => {
        try {
            const coursesData = await getCourses()
            setActiveCourse(getActiveCourse(coursesData))
            setCourses(coursesData)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchCourses()
    }, [])

    return (
        <Context.Provider
            value={{
                activeCourse,
                setActiveCourse,
                courses
            }}  
        >
            {props.children}
        </Context.Provider>
    );
};

export default CourseProvider;
